import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksAllHandMadeWorks(options = {}) {
  return _apiRequestWrap(
    ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS,
    ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS].GET_DONE_WORKS_ALL_HAND_MADE_WORKS,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS].GET_DONE_WORKS_ALL_HAND_MADE_WORKS]: _getDoneWorksAllHandMadeWorks
}
